import base from './base.yaml'
import docs from './docs'
import settings from './settings.yaml'
import stage from './stage.yaml'
import tamagotchi from './tamagotchi'

export default {
  base,
  docs,
  settings,
  stage,
  tamagotchi,
}
